import type useSettlementsStore from "./useSettlementsStore";

type UseSettlementsStore = typeof useSettlementsStore;

let useSettlementsStoreRef: UseSettlementsStore | null = null;

/** Call once from `main.ts` after `app.use(pinia)`. */
export function registerSettlementsStore(
	useSettlementsStore: UseSettlementsStore,
): void {
	useSettlementsStoreRef = useSettlementsStore;
}

export function isSettlementsStoreRegistered(): boolean {
	return useSettlementsStoreRef !== null;
}

export function getSettlementsStore(): ReturnType<UseSettlementsStore> {
	if (!useSettlementsStoreRef) {
		throw new Error(
			"Settlements store not registered — call registerSettlementsStore from main.ts",
		);
	}
	return useSettlementsStoreRef();
}
